import React from 'react'
import { graphql } from 'gatsby'
import { SectionTitle, SectionDescription } from '../components/Section'
import { PageContainer } from '../components/Container'
import { LatestArticles } from '../containers/LatestArticles'
import { Seo } from '../containers/Seo'

export default function BlogPage({ data }) {
  return (
    <>
      <Seo title="León G. Martínez Ostos — Blog" />
      <PageContainer>
        <SectionTitle>Blog</SectionTitle>
        <SectionDescription>
          Here you can find my thoughts expressed in an article, besides sharing
          the knowledge I am acquiring in my career as a web developer. Enjoy!.
        </SectionDescription>
        <LatestArticles edges={data.allMdx.edges} />
      </PageContainer>
    </>
  )
}

export const pageQuery = graphql`
  query($langKey: String!) {
    allMdx(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        frontmatter: { published: { ne: false } }
        fields: { langKey: { eq: $langKey } }
      }
    ) {
      edges {
        node {
          excerpt(pruneLength: 190)
          id
          fields {
            link
          }
          frontmatter {
            title
            slug
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`

// export const pageQuery = graphql`
//   query($langKey: String!) {
//     en: allMdx(
//       limit: 5
//       sort: { fields: [frontmatter___date], order: DESC }
//       filter: {
//         frontmatter: { published: { ne: false } }
//         fields: { langKey: { eq: $langKey } }
//       }
//     ) {
//       ...ConnectionFields
//     }

//     es: allMdx(
//       limit: 5
//       sort: { fields: [frontmatter___date], order: DESC }
//       filter: {
//         frontmatter: { published: { ne: false } }
//         fields: { langKey: { eq: "es" } }
//       }
//     ) {
//       ...ConnectionFields
//     }
//   }

//   fragment ConnectionFields on MdxConnection {
//     edges {
//       node {
//         excerpt(pruneLength: 190)
//         id
//         fields {
//           link
//         }
//         frontmatter {
//           title
//           slug
//           date(formatString: "MMMM DD, YYYY")
//         }
//       }
//     }
//   }
// `
